import React, { memo, useEffect, useRef, useState } from 'react';
import Highcharts from 'highcharts/highmaps';
import classnames from 'classnames';
import HighchartsReact from 'highcharts-react-official';
import mapData from './world.geo.json';
import { chartStyle } from '../config';
import { SingleSideTooltip, SharedTooltip, PointTooltip } from './LEtooltip';
import LESeriesOptions, { isPointType } from './LESeriesOptions';
import useTheme from '@hooks/useTheme';

const DefaultZooms = [0.5, 1.6];

const DefaultOption = {
  chart: {
    map: mapData,
    styleMode: true,
    borderWidth: 0,
    animation: false,
  },
  tooltip: {
    style: {
      color: '#333333',
      fontSize: '0.75rem',
      fontFamily: 'Helvetica Neue,Arial',
    },
    backgroundColor: '#ffffff',
    borderColor: '#ffffff',
    useHTML: true,
    formatter() {
      const that = this;
      if (isPointType(that.series.name)) {
        return PointTooltip(that);
      }

      if (!that.point.others) {
        return null;
      }
      if (!that.point.others.buyer) {
        return SingleSideTooltip(that);
      }
      // shared
      return SharedTooltip(that);
    },
  },
  colors: ['#D3D3D3'],
  credits: false,
  title: {
    text: null,
  },

  mapNavigation: {
    enabled: true,
  },
  legend: { enabled: false },
  colorAxis: {
    dataClasses: [],
  },
  plotOptions: {
    map: {
      allAreas: false,
      joinBy: ['iso-a3', 'code'],
    },
  },
};

const LEMap = (props) => {
  const { expand } = props;
  const [zoom, setZoom] = useState(DefaultZooms[0]);
  const { theme } = useTheme();
  const isLightMode = theme === 'light';

  const chartRef = useRef(null);
  // const [options, setOption] = useState(DefaultOption);

  useEffect(() => {
    try {
      if (chartRef && chartRef.current && chartRef.current.chart.reflow) {
        chartRef.current.chart.reflow();
        chartRef.current.chart.redraw();
        console.log('...redraw');
      }

      setZoom(expand ? DefaultZooms[1] : DefaultZooms[0]);
    } catch (error) {
      console.error(error);
    }
  }, [expand]);

  const seriesData = new LESeriesOptions(props).getOptions();
  console.log('seriesData: ', seriesData);
  const options = {
    ...DefaultOption,
    series: seriesData,
    mapView: {
      projection: Highcharts.merge({
        name: 'Miller',
        projectedBounds: 'world',
      }),
      center: [26, 30],
      zoom,
    },
  };

  console.log('options: ', options);
  return (
    <div
      className={classnames('le-map-wrapper', {
        'highcharts-dark': !isLightMode,
        'highcharts-light': isLightMode,
        expanded: expand,
        original: !expand,
      })}
    >
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        constructorType="mapChart"
        options={options}
        containerProps={{
          style: chartStyle,
        }}
      />
    </div>
  );
};

LEMap.propTypes = {};

export default memo(LEMap);
